<app-pat-payment-panel-paygreen-generic
  type="PAYGREEN_LUNCHR"
></app-pat-payment-panel-paygreen-generic>
